document.addEventListener("DOMContentLoaded", function () {
  const mainEl = document.querySelector('.product-offer__main-slider');
  const navEl = document.querySelector('.product-offer__nav-slider');

  if (!mainEl || !navEl) return;

  function syncNavHeight() {
    if (window.innerWidth > 979) {
      navEl.style.height = mainEl.offsetHeight + 'px';
    } else {
      navEl.style.height = 'auto';
    }
  }

  syncNavHeight();

  window.addEventListener('resize', syncNavHeight);

  const sliderThumbnail = new Swiper('.product-offer__nav-slider', {
    slidesPerView: 6.1,
    spaceBetween: 8,
    direction: 'vertical',
    watchSlidesProgress: true,
    watchSlidesVisibility: true,

    breakpoints: {
      0: {
        direction: 'horizontal',
        slidesPerView: 6,
      },

      980: {
        direction: 'vertical',
        slidesPerView: 5.183,
        spaceBetween: 10,
      }
    }
  });

  const sliderProdMain = new Swiper('.product-offer__main-slider', {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: false,

    thumbs: {
      swiper: sliderThumbnail
    }
  });
});

// product offer
document.addEventListener('DOMContentLoaded', () => {
  const variantItems = document.querySelectorAll('.product-offer__variant-item');
  const variantInput = document.getElementById('selected-variant-id');
  const buyNowBtns = document.querySelectorAll('.js-buy-now');
  const form = document.querySelector('.product-offer form') || document.querySelector('.product-offer__form form');
  const stickyPrice = document.querySelector('.product-offer__sticky .btn-price');
  const planItems = document.querySelectorAll('.product-offer__plan-item');
  const subPlanPrice = planItems[0]?.querySelector('.plan-price');
  const subPlanCompare = planItems[0]?.querySelector('.plan-compare');

  const oneTimePlanPrice = planItems[1]?.querySelector('.plan-price');
  const oneTimePlanCompare = planItems[1]?.querySelector('.plan-compare');

  const subscriptionCheckbox = document.getElementById('offer-subscription');

  const btnPrices = document.querySelectorAll('.btn-price');
  const btnCompares = document.querySelectorAll('.btn-compare');

  const selectedPrice = document.querySelector('.el-selected-price');
  const selectedCompare = document.querySelector('.el-selected-compare');
  const selectedBadge = document.querySelector('.el-selected-badge');

  if (form) {
    form.addEventListener('submit', e => e.preventDefault());
  }

  function cleanMoney(value) {
    if (!value) return '';
    return value.replace(/<\/?span[^>]*>/g, '').trim();
  }

  function getSelectedVariant() {
    return document.querySelector('.product-offer__variant-item.selected');
  }

  function getVariantSellingPlanId(variantEl) {
    if (!variantEl) return '';

    return (
      variantEl.getAttribute('data-selling-plan-id') ||
      variantEl.dataset.sellingPlanId ||
      ''
    ).trim();
  }

  function syncSubscriptionSellingPlanId() {
    if (!subscriptionCheckbox) return;

    const sellingPlanId = getVariantSellingPlanId(getSelectedVariant());

    subscriptionCheckbox.dataset.sellingPlanId = sellingPlanId;
    subscriptionCheckbox.setAttribute('data-selling-plan-id', sellingPlanId);
  }

  function updatePrices() {
    const isSub = isSubscriptionSelected();
    syncSubscriptionSellingPlanId();

    variantItems.forEach(item => {
      const priceEl = item.querySelector('.el-price');
      const compareEl = item.querySelector('.el-compare-price');
      const supplyEl = item.querySelector('.product-offer__variant-subtitle');

      let price = cleanMoney(item.dataset.price);

      if (isSub && item.dataset.subscriptionPrice) {
        price = cleanMoney(item.dataset.subscriptionPrice);
      }

      if (priceEl) {
        priceEl.innerHTML = price;
      }

      if (compareEl) {
        compareEl.textContent = cleanMoney(item.dataset.comparePrice);
      }

      if (supplyEl) {
        supplyEl.textContent = isSub
          ? item.dataset.perServingSub
          : item.dataset.perServing;
      }
    });

    const selected = getSelectedVariant();
    if (!selected) return;

    const regularPrice = cleanMoney(selected.dataset.price);
    const subscriptionPrice = cleanMoney(
      selected.dataset.subscriptionPrice || selected.dataset.price
    );
    const comparePrice = cleanMoney(selected.dataset.comparePrice);

    if (subPlanPrice) {
      subPlanPrice.textContent = subscriptionPrice;
    }

    if (subPlanCompare) {
      if (comparePrice) {
        subPlanCompare.textContent = comparePrice;
        subPlanCompare.style.display = 'inline';
      } else {
        subPlanCompare.style.display = 'none';
      }
    }

    if (oneTimePlanPrice) {
      oneTimePlanPrice.textContent = regularPrice;
    }

    if (oneTimePlanCompare) {
      if (comparePrice) {
        oneTimePlanCompare.textContent = comparePrice;
        oneTimePlanCompare.style.display = 'inline';
      } else {
        oneTimePlanCompare.style.display = 'none';
      }
    }

    let activePrice = selected.dataset.price;

    if (isSub && selected.dataset.subscriptionPrice) {
      activePrice = selected.dataset.subscriptionPrice;
    }

    btnPrices.forEach(el => {
      el.textContent = cleanMoney(activePrice);
    });

    btnCompares.forEach(el => {
      if (selected.dataset.comparePrice) {
        el.textContent = cleanMoney(selected.dataset.comparePrice);
        el.style.display = 'inline';
      } else {
        el.style.display = 'none';
      }
    });

    if (stickyPrice) {
      stickyPrice.textContent = cleanMoney(activePrice);
    }
    
    if (selectedPrice) {
      selectedPrice.textContent = cleanMoney(activePrice);
    }

    if (selected.dataset.comparePrice) {
      selectedCompare.textContent = cleanMoney(selected.dataset.comparePrice);
      selectedCompare.style.display = 'inline';
    } else {
      selectedCompare.style.display = 'none';
    }

    const saveAmount = cleanMoney(selected.dataset.save);

    if (saveAmount && saveAmount !== '$0.00') {
      selectedBadge.textContent = `Save ${saveAmount}`;
      selectedBadge.style.display = 'flex';
    } else {
      selectedBadge.style.display = 'none';
    }
  }

  function isSubscriptionSelected() {
    return Boolean(
      document.querySelector('.product-offer__plan-item-subbed.active') ||
      subscriptionCheckbox?.checked
    );
  }

  function selectPlan(item) {
    if (!item) return;

    planItems.forEach(p => p.classList.remove('active'));
    item.classList.add('active');

    if (subscriptionCheckbox) {
      subscriptionCheckbox.checked = item.classList.contains(
        'product-offer__plan-item-subbed'
      );
    }

    updatePrices();
  }

  planItems.forEach(item => {
    item.addEventListener('click', event => {
      // Buy button handles its own plan selection before ATC
      if (event.target.closest('.js-buy-now')) return;
      selectPlan(item);
    });
  });

  // variant select
  variantItems.forEach(item => {
    item.addEventListener('click', () => {
      variantItems.forEach(v => v.classList.remove('selected'));
      item.classList.add('selected');
      variantInput.value = item.dataset.id;
      updatePrices();
    });
  });

  if (subscriptionCheckbox) {
    subscriptionCheckbox.addEventListener('change', updatePrices);
  }

  // Keep subscribe selected when Liquid marked it active
  const activeSubPlan = document.querySelector(
    '.product-offer__plan-item-subbed.active'
  );
  if (activeSubPlan) {
    selectPlan(activeSubPlan);
  } else if (subscriptionCheckbox) {
    subscriptionCheckbox.checked = false;
  }

  buyNowBtns.forEach(buyNowBtn => {
    buyNowBtn.addEventListener('click', async e => {
      e.preventDefault();
      e.stopPropagation();

      const planItem = buyNowBtn.closest('.product-offer__plan-item');
      const isOneTime = Boolean(
        planItem?.classList.contains('product-offer__plan-item-unsub')
      );

      // One-time stays one-time; everything else uses subscribe + selling_plan
      if (!isOneTime) {
        const subPlan =
          planItem?.classList.contains('product-offer__plan-item-subbed')
            ? planItem
            : document.querySelector('.product-offer__plan-item-subbed');
        if (subPlan) {
          selectPlan(subPlan);
        } else if (subscriptionCheckbox) {
          subscriptionCheckbox.checked = true;
        }
      } else if (planItem) {
        selectPlan(planItem);
      }

      const selected = getSelectedVariant();
      if (!selected) {
        return;
      }

      const variantId = selected.dataset.id;

      syncSubscriptionSellingPlanId();

      const sellingPlanId =
        getVariantSellingPlanId(selected) ||
        subscriptionCheckbox?.getAttribute('data-selling-plan-id') ||
        '';

      buyNowBtns.forEach(btn => {
        btn.classList.add('el-loading');
        btn.setAttribute('disabled', true);
      });

      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        const item = {
          id: variantId,
          quantity: 1
        };

        // Always include selling_plan unless One-time was clicked
        if (!isOneTime && sellingPlanId) {
          item.selling_plan = sellingPlanId;
        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });

        window.location.href = '/checkout';
      } catch (err) {
        console.error(err);

        buyNowBtn.classList.remove('el-loading');
        buyNowBtn.removeAttribute('disabled');
      }
    });
  });

  updatePrices();
});

// sticky button
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.el-site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});

// indicator
document.addEventListener('DOMContentLoaded', function () {
  const dateElement = document.querySelector('.product-offer__instock-date[data-timestamp]');
  if (dateElement) {
    try {
      const timestamp = parseInt(dateElement.dataset.timestamp, 10) * 1000;
      const locale = dateElement.dataset.locale || 'en';
      const jsDate = new Date(timestamp);

      const options = { month: 'long', day: 'numeric' };
      const formatter = new Intl.DateTimeFormat(locale, options);

      const parts = formatter.formatToParts(jsDate);

      let day = '';
      let month = '';

      parts.forEach(part => {
        if (part.type === 'day') day = part.value;
        if (part.type === 'month') month = part.value;
      });

      function getOrdinalSuffix(d) {
        const n = parseInt(d, 10);
        if (n > 3 && n < 21) return 'th';
        switch (n % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      }

      const suffix = getOrdinalSuffix(day);

      dateElement.textContent = `${month} ${day}${suffix}`;

    } catch (error) {
      console.error('Error formatting free shipping notice date:', error);
    }
  }
});

window.addEventListener('pageshow', () => {
  const btn = document.getElementById('buy-now');
  if (!btn) return;

  btn.classList.remove('el-loading');
  btn.disabled = false;
});

// faq
document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.product-offer__acc-item');

  items.forEach(item => {
    const trigger = item.querySelector('.product-offer__acc-item-title');
    const content = item.querySelector('.product-offer__acc-item-description');

    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.paddingBottom = '0px';

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach(otherItem => {
        const otherContent = otherItem.querySelector('.product-offer__acc-item-description');
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherContent.style.height = '0px';
          otherContent.style.paddingBottom = '0px';
        }
      });

      if (isOpen) {
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');

        content.style.height = 'auto';
        const fullHeight = content.scrollHeight + 'px';
        content.style.height = '0px';

        requestAnimationFrame(() => {
          content.style.height = fullHeight;
          content.style.paddingBottom = '20px';
        });
      }
    });
  });
});

// video
document.addEventListener('DOMContentLoaded', () => {
  const swiperVideo = new Swiper('.product-offer__video-slider', {
    loop: true,
    slidesPerView: 2.54,
    spaceBetween: 12,

    navigation: {
      nextEl: '.product-offer__video-next',
      prevEl: '.product-offer__video-prev',
    },

    on: {
      init: updateProgress,
      slideChange: updateProgress,
      progress: updateProgress,
    },

    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 12,
        centeredSlides: false,
      }
    },
  });

  function updateProgress(swiper) {
    const fill = document.querySelector(".product-offer__progress-fill");

    const current = swiper.realIndex + 1;
    const total = swiper.slides.length;

    const percent = (current / total) * 100;

    if (fill) {
      fill.style.width = `${percent}%`;
    }
  }
});